import React, { useState } from 'react';

import { useTranslation } from '@/i18n';
import { AnchorButton, Button } from '@/ui/controls';
import { ConfirmationModal } from '@/ui/controls/ConfirmationModal.component';
import { Spacer } from '@/ui/spacing';
import { BodySmall } from '@/ui/typography';

import { useLogout } from '../hooks';

interface LogoutButtonProps {}

export const LogoutButton: React.FC<LogoutButtonProps> = () => {
  const logout = useLogout();
  const [open, setOpen] = useState(false);

  const { t } = useTranslation('bookingManagement');

  return (
    <>
      <ConfirmationModal
        title={t('amendBookingRequest.account.logout.title')}
        isOpen={open}
        onRequestClose={() => setOpen(false)}
      >
        <BodySmall>{t('amendBookingRequest.account.logout.body')}</BodySmall>
        <Spacer s="m" />
        <Button onClick={logout}>
          {t('amendBookingRequest.account.logout.logoutButtonLabel')}
        </Button>
        <Spacer s="xxs" />
        <Button onClick={() => setOpen(false)} variant="secondary">
          {t('amendBookingRequest.account.logout.cancelButtonLabel')}
        </Button>
      </ConfirmationModal>
      <AnchorButton onClick={() => setOpen(true)}>
        {'('}
        {t('amendBookingRequest.account.logout.modalTriggerButtonLabel')}
        {')'}
      </AnchorButton>
    </>
  );
};
